import { styled as muiStyled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`
const Block = muiStyled('div')(({ theme, width, height, margin, radius }) => ({
  background: theme.palette.grey[200],
  height,
  width,
  margin: margin || '0px',
  borderRadius: radius || '1px',
  backgroundImage: `linear-gradient(
    to right,
    ${theme.palette.grey[200]} 0%,
    ${theme.palette.grey[50]} 20%,
    ${theme.palette.grey[200]} 40%,
    ${theme.palette.grey[200]} 100%
  )`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: `1200px ${height}`,
  display: 'inline-block',
  position: 'relative',
  animationDuration: '3s',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: shimmer,
  animationTimingFunction: 'linear',
}))

const ShimmerBlock = ({ width, height, radius, margin }) => {
  return (
    <>
      <Block height={height} margin={margin} radius={radius} width={width} />
    </>
  )
}

ShimmerBlock.propTypes = {
  height: PropTypes.string.isRequired,
  margin: PropTypes.string,
  radius: PropTypes.string,
  width: PropTypes.string.isRequired,
}

export default ShimmerBlock
